import styled from 'styled-components';

export const HeaderTag = styled.header`
    background: url('images/Header/header-bg.jpg') no-repeat;
    background-size: cover;
    height: 80vh
`